import { createContext, useCallback, useState } from 'react';
import { WithChildren } from '../types/utility';
import { sdkCallbacks } from '../features/session/sdk-callbacks';
import { callbackRegistry } from '../features/session/callback-registry';

export const AutoCloseContext = createContext({ close: () => {} });

export const AutoCloseContextProvider = ({ children }: WithChildren) => {
	const [closed, setClosed] = useState<boolean>(false);

	const close = useCallback(() => {
		executeCallbacks();
		setClosed(true);
	}, []);

	if (closed) return <div id="auto-closed-banking-app" style={{ display: 'none' }}></div>;

	return <AutoCloseContext.Provider value={{ close }}>{children}</AutoCloseContext.Provider>;
};

const executeCallbacks = () => {
	try {
		callbackRegistry.retrieve('onClose')();
		sdkCallbacks.execute('onClose');
	} catch (error: any) {}
};
